import React from 'react';
import { ConnectionTypes, AuxiliarOptions } from '../../../../constants/utils/connectionTypes';

export const ServiceCard = ({ isSelected, setSelectedUserConnection, service, progress, addOrRemove, isSocialNetwork, isInsurance, isDemo }) => {

    function isInsurance(str) {
		if (str === ConnectionTypes.voitureAssurance || str === ConnectionTypes.bateau || str === ConnectionTypes.moto || str === ConnectionTypes.scooter) {
			return true;
		}
		return false;
    }

    if(isDemo){
        return (
            <div className="form-group col col-lg-3 col-xl-2">
                <div className="card p-2 text-center picker-card">
                    <img className={"img-fluid mx-auto mt-auto mb-2 h-6 py-1" + ( isSocialNetwork || isInsurance ? ' my-3': '')} src={service.icon} alt={service.title} />
                    <h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? ' m-auto' : ' mx-auto mt-auto')}>{service.title}</h3>
                    <p className={"h5 mt-auto lh-copy" + (progress === 100 ? ' o-0' : '')}>À compléter</p>
                    <div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
                        <div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
                        <div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
                    </div>
                </div>
            </div>
        )
    }else{
        return (
            <div className="form-group col col-lg-3 col-xl-2">
                <div className={"card p-2 text-center picker-card" + (isSelected ? ' active' : '')} data-toggle="modal" data-backdrop="static" data-target="#servicesEdit" onClick={(e) => {
                    e.preventDefault();
                    if(isDemo) return;
                    setSelectedUserConnection(isSocialNetwork ? AuxiliarOptions.socialNetworks : isInsurance(service.connectionType) ? AuxiliarOptions.insurance : service);
                    addOrRemove(service);
                }}>
                    <img className={"img-fluid mx-auto mt-auto mb-2 h-6 py-1" + ( isSocialNetwork || isInsurance ? ' my-3': '')} src={service.icon} alt={service.title} />
                    <h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? ' m-auto' : ' mx-auto mt-auto')}>{service.title}</h3>
                    <p className={"h5 mt-auto lh-copy" + (progress === 100 ? ' o-0' : '')}>À compléter</p>
                    <div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
                        <div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
                        <div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
                    </div>
                </div>
            </div>
        )
    }
}